/* globals global, debug_timing_push */

import { report } from '../../services/report';
import { compareSubmitPayload } from './shadow-compare';

// Helper to handle common navigation event logic
function handleNavigationEvent(event, config) {
  debug_timing_push(config.timingCode);

  // Check for halt conditions or invalid keypress
  if (
    ($(event).attr('halt') && event.halt) ||
    (event &&
      event.type === 'keypress' &&
      event.key !== ' ' &&
      event.key !== 'Enter')
  ) {
    return;
  }

  // Set button states to 'disabled' to block further interaction
  if (config.disableJoinButton) {
    mainNav.joinButton.disable();
  }
  mainNav.backButton.disable();
  mainNav.nextButton.disable();
  mainNav.skipButton.disable();

  // Disable response buttons while request processing
  $('.response-button').css({ 'pointer-events': 'none' });

  Gryphon.analytics.trackEvent('respondent', config.analyticsLabel);

  $('#notification').hide();

  var data = config.getInitialData();
  var all_str = '';

  if (config.triggerBeforeSubmit) {
    Gryphon.events.emit('before_submit', event);
  }

  if (config.collectFormValues) {
    for (var x = 0; x < page_state.allvars.length; x++) {
      var v = page_state.allvars[x];
      var val = get_form_value(v);
      all_str += v + '|';

      if (val != null) {
        data[v] = val;
      }
    }

    for (var nm in page_state.vardata) {
      data[nm] = page_state.vardata[nm];
    }

    // Shadow-compare the store-derived payload against `data` and report
    // any divergence to New Relic. Does not read from or mutate `data`'s
    // submission; self-guarded so it can never block or delay the submit.
    compareSubmitPayload(data);
  } else {
    // Still need all_str for skip button
    for (var i = 0; i < page_state.allvars.length; i++) {
      var varName = page_state.allvars[i];
      all_str += varName + '|';
    }
  }

  if (config.collectTiming && page_state['starttime'] != null) {
    var endtime = Gryphon.util.get_page_time();
    data['__time__'] = Math.round(endtime - page_state['starttime']);
    data['__page_timing_source__'] = page_timing_source;
    if (config.includeDebugTimings && collect_debug_page_timings) {
      data['__debug_timings__'] = debug_timings;
    } else if (!config.includeDebugTimings) {
      data['__debug_timings__'] = debug_timings;
    }

    if (data['__time__'] < 0) {
      var message = '__time__: ' + data['__time__'];
      message += '; page_starttime: ' + page_state['starttime'];
      message += '; page_endtime: ' + endtime;
      message += '; source: ' + page_timing_source;
      report.logError({ name: 'Negative page timing', message: message }, true);
    }
  }

  if (config.setAllString) {
    data.__all__ = all_str;
  }
  if (config.setThisPage) {
    data.__this__ = page_state['this_page'];
  }
  if (config.setSpdConsent) {
    data.__spd_consent_text_shown__ = page_state['spd_consent_text_shown'];
  }
  if (config.includeFacebook && page_state['__facebook__']) {
    data.__facebook__ = JSON.stringify(page_state['__facebook__']);
  }
  if (page_state['__pg_context__']) {
    data.__pg_context__ = JSON.stringify(page_state['__pg_context__']);
  }

  get_next_question(data);
  return false;
}

// Navigation Click Event Handlers
global.click_next = function (event) {
  if ($('.dk-check').prop('checked')) {
    $('.image-highlight-input').val(null);
    $('.card-sort-input').prop('checked', false);
  }
  global.loading_buttons('join_button');
  global.loading_buttons('next_button');

  return handleNavigationEvent(event, {
    timingCode: 0,
    disableJoinButton: true,
    analyticsLabel: 'next question',
    getInitialData: function () {
      return { __submit__: 1 };
    },
    triggerBeforeSubmit: true,
    collectFormValues: true,
    collectTiming: true,
    includeDebugTimings: true,
    setAllString: true,
    setThisPage: true,
    setSpdConsent: true,
    includeFacebook: true,
  });
};

global.click_back = function (event) {
  global.loading_buttons('back_button');

  return handleNavigationEvent(event, {
    timingCode: 1,
    disableJoinButton: false,
    analyticsLabel: 'previous question',
    getInitialData: function () {
      return { __back__: 1 };
    },
    triggerBeforeSubmit: false,
    collectFormValues: false,
    collectTiming: false,
    setAllString: false,
    setThisPage: false,
    setSpdConsent: false,
    includeFacebook: false,
  });
};

global.click_skip = function (event) {
  return handleNavigationEvent(event, {
    timingCode: 3,
    disableJoinButton: false,
    analyticsLabel: 'skip question',
    getInitialData: function () {
      return { __submit__: '__skip__' };
    },
    triggerBeforeSubmit: true,
    collectFormValues: false,
    collectTiming: true,
    includeDebugTimings: false,
    setAllString: true,
    setThisPage: true,
    setSpdConsent: true,
    includeFacebook: false,
  });
};

global.loading_buttons = function (id) {
  $('#' + id).addClass('loading-button');
};

global.loaded_buttons = function () {
  $('button').removeClass('loading-button');
};
// End Navigation Click Event Handlers
